import React, { type HTMLAttributes } from 'react';
import c from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';

import type {
  ParagraphHighlightedItem as Type,
} from '../../../../types/uncinc_profile/paragraphs';
import { ButtonWrapper } from '../../../../components';

interface ParagraphHighlightedItemProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphHighlightedItem: React.FC<ParagraphHighlightedItemProps> = ({
  id,
  entity,
}) => {
  const highlightedItem = entity.toJS().field_highlighted_node[0].entity;
  const media = highlightedItem.field_media_item[0];
  const language = highlightedItem.langcode[0].value;
  const path = highlightedItem.paths[language];

  const wrapperClasses = c(
    'Paragraph',
    'ParagraphMeta',
    'ParagraphHighlightedItem',
    highlightedItem.type[0].target_id,
  );

  const itemClasses = c('col-12', {
    'col-md-6': media,
  });

  return (
    <div id={id} className={wrapperClasses}>
      <Container>
        <div className="row">
          {media && (
            <div className="col-12 col-md-6">
              <DynamicMediaItem
                media={media}
              />
            </div>
          )}
          <div className={itemClasses}>
            <h2>{highlightedItem.title[0].value}</h2>
            <WysiwygField html={highlightedItem.body[0]?.processed} />
            <ButtonWrapper href={path} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphHighlightedItem;
